export default __webpack_public_path__ + "static/media/MetaMaskFox.9a9b84e9.svg";